import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { useSolicitudes } from "../../hooks/useSolicitudes";
import TablaSolicitudes from "./components/TablaSolicitudes";
import { isValidEmail } from "../../helpers/datosVarios";
import Swal from "sweetalert2";
import VacationSelect from "./components/VacationSelect";

export const SolicitarVacaciones = () => {


  const location = useLocation();
  const datos = location.state || {}; // Si no hay datos, asigna un objeto vacío
  
  const { solicitudes, loading, setSolicitudes, solicitarVacaciones } = useSolicitudes( localStorage.getItem('conid') );

  const [dateRange, setDateRange] = useState({
    startDate: moment(),
    endDate: null,
  });

  const [totalDiasHabiles, setTotalDiasHabiles] = useState(0);

  const [encargado, setEncargado] = useState('')


  const saldoNormales = datos.saldoNormales ? datos.saldoNormales.replace(".", ",") : "0,0";
  const normalesNumber = parseFloat(saldoNormales.replace(",", "."));

  const solicitar = async() => {

    if(!isValidEmail(encargado)){
      return Swal.fire('Email no válido')
    }

    const solicitud = {
      "sid": 8208,
      "empid": "77777777-7",
      "conid": 398888,
      "diash": totalDiasHabiles,
      "desde": dateRange.startDate,
      "hasta": dateRange.endDate,
      "estado": "P",
      "encargado": encargado
    }

        await solicitarVacaciones(solicitud)
        setTotalDiasHabiles(0)
        setDateRange({startDate: moment(),endDate: null,})
   
  }

  const pendiente = solicitudes.filter( item => item.estado === 'P' )


  return (
    <div>
      <div className="titulo">
        <p>Solicita tus Vacaciones</p>
      </div>

      {/* Datos de saldo */}
      <div style={{ fontSize: "2rem" }}>
        <div className="recuadros">
          <div className="contenedorLeftdata">
            <p>Normales a la Fecha</p>
          </div>
          <p style={{textAlign:'center'}} className="textoRightData">{saldoNormales} {!datos.resultado ? "Días Hábiles" : ""}</p>
        </div>

        <div className="recuadros">
          <div className="contenedorLeftdata">
            <p>Progresivas a la Fecha</p>
          </div>
          <p style={{textAlign:'center'}} className="textoRightData">{datos.saldoProgresivas} {!datos.resultado ? "Días Hábiles" : ""}</p>
        </div>
      </div>

      {/* Selección de vacaciones */}
      <div style={{ fontSize: "2rem", width: "fit-content", margin: "0 auto" }}>

        {
          pendiente.length>0 ? 
          <div>Tienes una solicitud pendiente, espera su respuesta para solicitar mas vacaciones.</div>
          :
          <div>
              <p>Puedes Solicitar un máximo de {saldoNormales} {!datos.resultado ? "Días Hábiles" : ""}</p>

              <VacationSelect dateRange={dateRange} setDateRange={setDateRange} setTotalDiasHabiles={setTotalDiasHabiles} />
          </div>
        }

       

        {totalDiasHabiles > 0 && <p style={{ textAlign: "center" }}>Días Hábiles seleccionados: {totalDiasHabiles}</p>}

        {totalDiasHabiles > normalesNumber && (
          <p style={{ textAlign: "center", color: "red" }}>Selecciona menos días hábiles para continuar</p>
        )}

        {totalDiasHabiles > 0 && totalDiasHabiles <= normalesNumber && (
          <div style={{ width: "fit-content", margin: "0 auto" }}>
            <p>Ingresar correo Jefe/Supervisor</p>
            <input onChange={ (e) => setEncargado(e.target.value) } style={{ width: "100%", borderRadius: 3 }} />
            <button
              onClick={solicitar}
              style={{
                width: "100%",
                cursor: "pointer",
                borderRadius: 3,
                border: 0,
                marginTop: 10,
                backgroundColor: "#6970E1",
                color: "white",
              }}
            >
              Solicitar
            </button>
          </div>
        )}
      </div>

      {/* Tabla de solicitudes */}

      
        <TablaSolicitudes setSolicitudes={setSolicitudes} solicitudes={solicitudes} resultado={datos.resultado} />

      
     
    </div>
  );
};
